module.exports = __webpack_public_path__ + "static/media/german-alphabet-robot.18a2cdbc.jpg";